export default "__VITE_ASSET__B_JtqHc0__"